export default "__VITE_ASSET__Nfc0Rmmh__"